import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
export var QuestionType = /*#__PURE__*/function () {
  function QuestionType() {
    _classCallCheck(this, QuestionType);
  }

  _createClass(QuestionType, null, [{
    key: "isBasicQuestionType",
    value: function isBasicQuestionType(type) {
      return this.basicQuestionTypes.includes(type);
    }
  }, {
    key: "isGroupQuestionType",
    value: function isGroupQuestionType(type) {
      return this.groupQuestionTypes.includes(type);
    }
  }]);

  return QuestionType;
}();

_defineProperty(QuestionType, "Essay", 'essay');

_defineProperty(QuestionType, "SingleChoice", 'single-choice');

_defineProperty(QuestionType, "MultipleChoice", 'multiple-choice');

_defineProperty(QuestionType, "FillInBlank", 'fill-in-blank');

_defineProperty(QuestionType, "Matching", 'matching');

_defineProperty(QuestionType, "basicQuestionTypes", [QuestionType.Essay, QuestionType.SingleChoice, QuestionType.MultipleChoice]);

_defineProperty(QuestionType, "groupQuestionTypes", [QuestionType.FillInBlank, QuestionType.Matching]);